import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  renderCustomComponent,
  renderHistoryComponent,
  setWidgetConfig,
  toggleMsgLoader,
  toggleSendDisabled,
  WidgetMain,
} from './components/index.js';
import axios from 'axios';
import { addUserMessage } from './components/index.js';
import { toggleWidget } from './components/index.js';
import style from './app.module.css';
import './chat.module.css';
import WebSocketManager from './manager/WebSocketManager';
import { getUUID } from './utils/uuid';
import Typing from './components/Typing.jsx';
import PreChat from './components/preChat.jsx';
import OfflineDisplay from './components/offlineDisplay.jsx';
import { Widget } from './components/index.js';
import {
  checkUserId,
  delay,
  getTabVisibility,
  getUserId,
  hex2rgba,
  local,
  messageTypeArray,
  removeSessionId,
  removeSubmitEvent,
  removeUserId,
  setSubmitEvent,
  setTabVisibility,
  setUserId,
  timeStamp,
} from './utils/helper.js';
import { getCorrectComponent } from './utils/getCorrectComponent.js';
import useAudioWithInteraction from './hooks/useNotifiactionSound.js';
import playNotificationSound from './hooks/useNotifiactionSound.js';
import RatingScreen from './components/RatingScreen.js';
import store from './components/Widget/store/index.js';
// import { resetMessages } from './components/Widget/store/actions/index.js';
import {
  resetMessages,
  setIsChatFullScreen,
  setRecentMessage,
  setSessionAvailable,
  setSessionStarted,
  setShowSenderComponent,
  setTotalMessageCount,
  setLoadingMessages,
} from './components/Widget/store/dispatcher.js';
import ConsoleUtils from './utils/console.js';

const webSocketManager = new WebSocketManager();
let receiveTypingTimeout;
let isChatClosed = false;
let isSessionAvailable = false;
let sessionStartedTimeout;
let totalMessageCount = 0;

const App = () => {
  const audioRef = useRef(null);
  const [interactionInitialized, setInteractionInitialized] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [config, setConfig] = useState({});
  const [configData, setConfigData] = useState({});
  // const [loading, setLoading] = useState(true);
  const [soundEnable, setSoundEnable] = useState(false); //TODO
  const [title, setTitle] = useState('ACAI');
  const [status, setStatus] = useState('Welcome to our website. Ask us anything 🎉');
  // const [color, setColor] = useState('#000000');
  const [bgcolor, setBGColor] = useState('#000000');
  // const [enablePreChat, setEnablePreChat] = useState(true);
  const [offlineMessage, setOfflineMessage] = useState('We are currently Offline');
  const [offlineStatus, setOfflineStatus] = useState('Offline');
  // const [preChatData, setPreChatData] = useState();
  const [isTyping, setIsTyping] = useState(false);
  const [showWidget, setShowWidget] = useState(false);
  // const [currentAudio, setCurrentAudio] = useState(null);
  const [typingTimeout, setTypingTimeout] = useState(null);
  // const [storage, setStorage] = useState(false);
  // const [user, setUser] = useState();
  // const [soundFlag, setSoundFlag] = useState(true);
  // const [showRatingScreen, setShowRatingScreen] = useState(false);
  const [showStartScreen, setShowStartScreen] = useState(false);
  const [widgetBlocks, setWidgetBlocks] = useState();
  const [activeWidget, setActiveWidget] = useState('Home');
  const [webchatConfig, setWebchatConfig] = useState();
  // const [isChatClosed, setIsChatClosed] = useState(false);
  // let enablePreChatDisplay = true;

  const DesigningConfig = useCallback(
    (data) => {
      // setLoading(false);
      if (data) {
        if (data?.widgetConfig?.currentStatus === 'assigned') setActiveWidget('ChatBot');
        setWidgetBlocks(data?.widgetConfig?.widgetBlocks);
        const lookAndFeel = data?.widgetConfig?.lookAndFeel || {};
        setBGColor(lookAndFeel?.backgroundColor);
        // setColor(lookAndFeel?.textColor);
        setSoundEnable(lookAndFeel?.enableWidgetSounds);
        const getStarted = data?.widgetConfig?.getStarted;
        setTitle(getStarted.title);
        setStatus(getStarted.status);
        const preChat = data?.widgetConfig?.preChatSurvey;
        // setEnablePreChat(preChat?.display);
        // if (preChat?.display) {
        //   setPreChatData(preChat);
        // } else {
        //   setLoading(false);
        //   setStorage(true);
        // }
        if (data?.widgetConfig?.isBusinessOpen || data?.widgetConfig?.isSessionAvailable) {
          setShowWidget(true);
        }
        const offline = data?.widgetConfig?.widgetVisibility;
        if (offline?.showWhenOffline) {
          setOfflineMessage(offline.offlineMessage);
          setOfflineStatus(offline.offlineStatus);
        }
        setPageLoading(false);
      }
    },
    [config]
  );

  useEffect(() => {
    // Event handler for initial blank sound
    const initializeAudioContext = () => {
      if (!interactionInitialized) {
        if (!audioRef.current) {
          audioRef.current = new Audio('');
          audioRef.current.preload = 'auto';
        }
        audioRef.current.play().catch((error) => {
          ConsoleUtils.error('Initialization playback error:', error);
        });
        // Mark interaction as initialized and remove event listener
        setInteractionInitialized(true);
        window.removeEventListener('mousemove', initializeAudioContext);
      }
    };

    // Add mousemove event listener for the initial interaction
    if (!interactionInitialized) {
      window.addEventListener('mousemove', initializeAudioContext);
    }

    return () => {
      // Cleanup: Remove event listener if not already removed
      window.removeEventListener('mousemove', initializeAudioContext);
    };
  }, [interactionInitialized]);

  let notificationPlayed = false;
  let notificationPlayed1 = false;

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      notificationPlayed = true;
    } else {
      notificationPlayed = false;
    }
    setTabVisibility(config.widgetId, notificationPlayed);
  };

  const handleStorageChange = (event) => {
    if (event.key === 'tabVisibility_' + config?.widgetId) {
      notificationPlayed = JSON.parse(event.newValue);
    }

    if (event.key === 'resetChatTriggered') {
      handleResetChat(); // Call resetChat logic here
    }
  };

  // document.addEventListener('visibilitychange', () => {
  //   notificationPlayed = document.hidden;
  // });

  const selectTypingMessage = (data) => {
    if (data?.display) {
      return data?.display;
    } else {
      if (data?.subType === 'thinking') return 'Thinking';
      else if (data?.subType === 'lookingForInfo') return 'Looking For Info';
      else if (data?.subType === 'finalizing') return 'Finalizing';
      else return 'Typing';
    }
  };

  const receiveMessage = (message) => {
    const event = new CustomEvent('receiveMessage', {
      detail: message,
    });
    window.dispatchEvent(event);

    if (message?.error) {
      ConsoleUtils.log('message error', message);
      return;
    }

    if (!isSessionAvailable) return;

    if (message?.type === 'sessionStarted') {
      if (message?.status) {
        setSessionStarted(true);
        clearInterval(sessionStartedTimeout);
      } else {
        handleResetOnStartedSession();
        setSessionStarted(false);
        clearInterval(sessionStartedTimeout);
      }
    }

    removeTypingNode();
    const type = message?.type || '';
    const messageType =
      (message?.type === 'newPage'
        ? message?.content?.data[0]?.message?.type !== 'close'
          ? message?.content?.data[0]?.message?.type
          : ''
        : message?.type) || '';
    if (messageType === 'dictation') return;
    if (messageTypeArray.includes(messageType)) setRecentMessage(message);
    if (type === 'typing') handleReceiveTyping(message, selectTypingMessage(message));
    else if (type === 'newPage') {
      isChatClosed = false;
      loadMessage(message?.content);
      setLoadingMessages(false);
      setTotalMessageCount(message?.content?.count ?? 0);
      totalMessageCount = message?.content?.count ?? 0;
      // } else if (type === 'resolve' || type === 'close') {
      // setShowRatingScreen(true);
      // removeUserId(configData?.config?.widgetId);
      // } else if (type === 'rating') {
      //   setShowRatingScreen(false);
    } else {
      setIsTyping(false);
      isChatClosed = false;

      // if (!notificationPlayed || notificationPlayed1) {
      //   if (message.mode && message.mode === 'stop') {
      //     playNotificationSound(soundEnable);
      //   }
      //   if (!message.mode && message.mode !== 'start') {
      //     playNotificationSound(soundEnable);
      //   }
      // }

      // if ('mode' in message) {
      //   if (message.mode === 'start') toggleSendDisabled(true);
      //   if (message.mode === 'continue') toggleSendDisabled(true);
      //   if (message.mode === 'stop') toggleSendDisabled(false);
      // } else {
      //   toggleSendDisabled(false);
      // }

      if (receiveTypingTimeout) {
        toggleMsgLoader({
          messageLoader: false,
          messageFrom: message?.from,
          messageType: selectTypingMessage(message),
        });
        clearTimeout(receiveTypingTimeout);
      }
      if (message?.payloadType !== 'event') {
        setLoadingMessages(false);
        totalMessageCount += 1;
        console.log(totalMessageCount, 'app+++++++++++++++');

        setTotalMessageCount(totalMessageCount);
        renderCustomComponent(MessageRenderer, { message }, true);
      }
    }
    ConsoleUtils.log('isChatClosed:-', isChatClosed);

    if (type === 'close' && !isChatClosed) {
      isChatClosed = true;
      renderCustomComponent(MessageRenderer, { message }, true);
      setSessionAvailable(false);
      isSessionAvailable = false;
      setRecentMessage({});
      if (configData?.widgetConfig?.lookAndFeel && !configData?.widgetConfig?.lookAndFeel?.rating) {
        handleRatingSubmit();
      } else {
        // removeUserId(configData?.config?.widgetId);
        sendMessageToParent({ type: 'END_CHAT' });
      }
    }
  };

  const handleResetOnStartedSession = () => {
    setSessionAvailable(false);
    isSessionAvailable = false;
    setRecentMessage({});
    resetMessages([]);
    webSocketManager.removeAllSocketMessages();
    removeSessionId(config.widgetId);
    removeUserId(config.widgetId);
    sendMessageToParent({ type: 'END_CHAT' });
    setActiveWidget('Message');
  };

  const handleReceiveTyping = (message, messageType) => {
    toggleMsgLoader({ messageLoader: true, messageFrom: message?.from, messageType: messageType });
    if (receiveTypingTimeout) {
      clearTimeout(receiveTypingTimeout);
    }

    receiveTypingTimeout = setTimeout(
      () => {
        toggleMsgLoader({
          messageLoader: false,
          messageFrom: message?.from,
          messageType: messageType,
        });
      },
      message?.timeout ? message?.timeout * 1000 : 10000
    );
  };

  const loadMessage = (msg) => {
    msg?.data?.map((ele) => {
      renderHistoryComponent(MessageRenderer, { message: ele?.message }, true);
    });
  };

  const socketEventHandler = (receivedEvent) => {
    if (
      receivedEvent?.payloadType === 'event' &&
      receivedEvent.event?.type === 'typing' &&
      receivedEvent.event.status === true
    ) {
      renderCustomComponent(Typing, {}, true);
    } else if (
      receivedEvent?.payloadType === 'event' &&
      receivedEvent.event?.type === 'typing' &&
      receivedEvent.event.status === false
    ) {
      removeTypingNode();
    }
  }; //TODO

  function MessageRenderer({ message }) {
    const data = getCorrectComponent(message, configData);
    // useNotificationSound(soundEnable, message);
    // useAudioWithInteraction(soundEnable, message);
    if (message?.from === 'customer') {
      if (data) {
        return <div className="rcw-client">{data}</div>;
      }
    } else {
      if (data) {
        if (data?.props?.hasOwnProperty('latitude') || data?.type?.name === 'CarousalMsg') {
          return <div className={`${style['left-message-location']}`}>{data}</div>;
        }
        if (
          data?.props?.children?.props?.message === '' &&
          data?.props?.children?.props?.type === 'video/mp4'
        ) {
          return <div className={`${style['left-message-video']}`}>{data}</div>;
        }
        if (data?.props?.children?.props?.message === '') {
          return <div className={`${style['left-message-image']}`}>{data}</div>;
        }
        if (data?.props?.hasOwnProperty('src')) {
          return <div className={`${style['left-message-audio']}`}>{data}</div>;
        }
        return <div className={`${style['left-message']}`}>{data}</div>;
      } else {
        return null;
      }
    }
  }

  function removeTypingNode() {
    try {
      const typingNode = document.getElementById('typing');
      if (typingNode) {
        typingNode.parentElement && typingNode.parentElement.remove();
      }
    } catch (error) {
      ConsoleUtils.error('Remove Typing:', error);
    }
  }

  const sendMessageToParent = (message) => {
    window.parent.postMessage(message, '*');
  };

  const receiveMessageFromParent = (event) => {
    if (event.data.type === 'CONFIG_RESPONSE') {
      setConfig(event?.data?.config);
      setConfigData(event?.data);
      // enablePreChatDisplay = event?.data?.widgetConfig?.preChatSurvey?.display;
      ConsoleUtils.log(`CONFIG_RESPONSE event.data ---`, event.data);
      setSessionAvailable(event?.data?.widgetConfig?.isSessionAvailable);
      isSessionAvailable = event?.data?.widgetConfig?.isSessionAvailable;
      setWidgetConfig(event?.data);
      DesigningConfig(event.data);
      setWebchatConfig(event?.data?.webChat);
      const config = event?.data?.config || {};
      setUserId(event?.data?.config?.widgetId, event?.data?.config?.customerId);
      // if (config.customerId) {
      //   setUser(config.customerId);
      // }
      if (event?.data?.widgetConfig?.isSessionAvailable) {
        // let userId = getUserId(config.widgetId);
        // setStorage(true);
        connectWebSocket(config.customerId, config);
        webSocketManager.send({
          id: '5397b5bf-e413-4dbc-bf9d-47bb7b5fbf53',
          payloadType: 'event',
          type: 'newPage',
          content: {
            pageNo: 1,
            pageSize: 20,
          },
        });
      }
    } else if (event.data.type === 'CHECK_SHOW_WIDGATES') {
      notificationPlayed1 = !event.data.cond;
    } else if (event?.data?.type === 'CONFIG_CHAT_FULL_SCREEN') {
      setIsChatFullScreen(event?.data?.isChatFullScreen);
    }
    return event;
  };

  const connectWebSocket = useCallback(
    (userId, config) => {
      webSocketManager.init({
        url: config?.url,
        accessKey: config?.accessKey,
        widgetId: config?.widgetId,
        customerId: userId,
      });
    },
    [config]
  );

  const handleResetChat = async (event) => {
    const message = {
      // id: '5397b5bf-e413-4dbc-bf9d-47bb7b5fbf53',
      id: getUUID(),
      sessionId: '',
      payloadType: 'event',
      type: 'close',
    };
    webSocketManager.send(message);
  };

  const handleRatingSubmit = async () => {
    // setShowRatingScreen(false);
    if (configData?.config?.widgetId === config.widgetId) {
      fireEventAcrossTabs('triggerRatingAction');
    }
    setActiveWidget('Message');
    resetMessages([]);
    webSocketManager.removeAllSocketMessages();
    sendMessageToParent({ type: 'END_CHAT' });
    sendMessageToParent({ type: 'GET_CONFIG_API_DATA' });
    setSessionAvailable(false);
    isSessionAvailable = false;
    removeSessionId(config.widgetId);
    if (configData?.widgetConfig?.preChatSurvey?.display) {
      // removeUserId(config.widgetId);
      // setLoading(true);
      // setStorage(false);
    } else {
      // removeUserId(config.widgetId);
      // setShowStartScreen(true);
      // await delay(500);
      // const messageToSend = {
      //   id: getUUID(),
      //   payloadType: 'event',
      //   type: 'startSession'
      // };
      // webSocketManager.send(messageToSend);
    }
  };

  let lastProcessedTime = 0;

  const storageEventHandler = (event) => {
    if (event.key === 'submit-event_' + config.widgetId) {
      const data = JSON.parse(event.newValue);

      if (!data?.timestamp) return;

      if (data?.timestamp > lastProcessedTime) {
        lastProcessedTime = data.timestamp; // Update last processed time

        if (data?.type === 'triggerRatingAction') {
          handleTriggerRatingAction();
        }

        if (data?.type === 'triggerPrechatAction') {
          handleTriggerPrechatAction();
        }
      }
    }
  };

  function handleTriggerRatingAction() {
    setActiveWidget('Message');
    resetMessages([]);
    webSocketManager.removeAllSocketMessages();
    sendMessageToParent({ type: 'END_CHAT' });
    sendMessageToParent({ type: 'GET_CONFIG_API_DATA' });
    setSessionAvailable(false);
    isSessionAvailable = false;
    removeSessionId(config.widgetId);
  }

  function handleTriggerPrechatAction() {
    resetMessages([]);
    setShowSenderComponent(false);
    handleFormSubmitConfig();
  }

  function handleRestoreChatMessages() {
    // resetMessages([]);
    // webSocketManager.removeAllSocketMessages();
    // delay(500);
    const userId = getUserId(configData?.config?.widgetId);
    connectWebSocket(userId, configData?.config);
  }

  // Example: Dispatching an event with timestamp
  function fireEventAcrossTabs(type) {
    const payload = {
      type,
      timestamp: Date.now(),
    };

    setSubmitEvent(config.widgetId, payload);

    setTimeout(() => {
      removeSubmitEvent(config.widgetId);
    }, 100); // Clear the key after 100ms
  }

  useEffect(() => {
    if (config?.widgetId && configData?.config?.widgetId) {
      setStorageEvent();
      webSocketManager.addListener('message', receiveMessage);
      toggleWidget();
      window.addEventListener('resetChat', handleResetChat);
      window.addEventListener('restoreChatMessages', handleRestoreChatMessages);
      window.addEventListener('ratingSubmit', handleRatingSubmit);
      window.addEventListener('resetActiveWidget', handleActiveWidget);
      const storedVisibility = getTabVisibility(config.widgetId);
      // if (storedVisibility !== null) {
      //   notificationPlayed = storedVisibility;
      // }
      notificationPlayed = true;
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('storage', handleStorageChange);
      window.addEventListener('reconnectSocket', reconnectSocket);
      return () => {
        webSocketManager.removeListener('message', receiveMessage);
        window.removeEventListener('resetChat', handleResetChat);
        window.removeEventListener('restoreChatMessages', handleRestoreChatMessages);
        window.removeEventListener('ratingSubmit', handleRatingSubmit);
        window.removeEventListener('resetActiveWidget', handleActiveWidget);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('storage', handleStorageChange);
        window.removeEventListener('reconnectSocket', reconnectSocket);
      };
    }
  }, [config, configData]);

  function setStorageEvent() {
    if (!window.isStorageListenerAttached) {
      window.addEventListener('storage', storageEventHandler);
      window.isStorageListenerAttached = true;
    }
  }

  const handleStartScreenSubmit = async () => {
    setShowStartScreen(false);
    // setShowRatingScreen(false);
    resetMessages([]);
    const userId = getUserId(config.widgetId);
    await delay(500);
    const messageToSend = {
      id: userId,
      payloadType: 'event',
      type: 'startSession',
    };
    webSocketManager.send(messageToSend);
  };

  const handleActiveWidget = () => {
    // resetMessages([]);
    // webSocketManager.removeAllSocketMessages();
    // removeSessionId(config.widgetId);
    // delay(500);
    setActiveWidget('Message');
  };

  const handleStartNewSession = () => {
    if (sessionStartedTimeout) {
      clearInterval(sessionStartedTimeout);
    }
    sessionStartedTimeout = setInterval(() => {
      webSocketManager.send({
        id: '5397b5bf-e413-4dbc-bf9d-47bb7b5fbf53',
        payloadType: 'event',
        type: 'sessionStarted',
      });
    }, 500);
    totalMessageCount = 0;
    setSessionAvailable(true);
    isSessionAvailable = true;
  };

  useEffect(() => {
    webSocketManager.addListener('open', handleStartNewSession);
    window.addEventListener('message', receiveMessageFromParent);
    sendMessageToParent({ type: 'GET_CONFIG' });
    return () => {
      webSocketManager.removeListener('open', handleStartNewSession);
      window.removeEventListener('message', receiveMessageFromParent);
    };
  }, []);

  // useEffect(() => {
  //   if (activeWidget !== 'ChatBot') {
  //     sendMessageToParent({
  //       type: 'CHAT_FULL_SCREEN',
  //       cond: false,
  //     });
  //   }
  // }, [activeWidget]);

  const handleTypingEvent = (newMessage) => {
    const message = {
      id: getUUID(),
      type: 'typing',
      payloadType: 'event',
      from: 'customer',
      content: {
        text: newMessage,
      },
    };
    webSocketManager.send(message);
  };

  const handleNewUserMessage = (newMessage, emoji) => {
    totalMessageCount += 1;
    setTotalMessageCount(totalMessageCount);
    sendMessageToParent({ type: 'AUDIO_CONFIG', flag: soundEnable });
    // playNotificationSound(true);
    if (typeof newMessage === 'object') {
      const imageResponse = newMessage?.data || {};
      const text = newMessage?.endText || '';
      const messageToSend = {
        id: getUUID(),
        type: imageResponse?.fileType || 'image',
        payloadType: 'message',
        from: 'customer',
        timeStamp: new Date(),
        content: {
          caption: text,
          ...imageResponse,
        },
      };
      // ConsoleUtils.log('objtosend', messageToSend);
      webSocketManager.send(messageToSend);
    } else {
      const messageToSend = {
        id: getUUID(),
        payloadType: 'message',
        type: 'text',
        from: 'customer',
        timeStamp: new Date(),
        content: {
          text: newMessage,
          emojis: emoji,
        },
      };
      ConsoleUtils.log('messTosend', messageToSend);
      setRecentMessage(messageToSend);
      webSocketManager.send(messageToSend);
    }
  };

  const handleKeyPress = (event) => {
    if (!isTyping) {
      handleTypingEvent(event.target.value);
      setIsTyping(true);
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      setTypingTimeout(
        setTimeout(() => {
          setIsTyping(false);
        }, 5000)
      );
    }
  };

  const handleFormSubmit = async (flag) => {
    // setEnablePreChat(flag);
    // setLoading(false);
    // setStorage(true);
    if (configData?.config?.widgetId === config.widgetId) {
      fireEventAcrossTabs('triggerPrechatAction');
      await delay(500);
    }
    resetMessages([]);
    setShowSenderComponent(false);
    handleFormSubmitConfig(flag);
    // sendMessageToParent({ type: 'GET_CONFIG_API_DATA' });
  };

  const handleFormSubmitConfig = async (flag) => {
    const maxRetries = 5;
    let attempt = 0;
    let retryTimeout = null;

    const fetchConfig = async () => {
      attempt++;
      try {
        const response = await axios({
          method: 'GET',
          url: `${config?.api}` + `/config/${config?.widgetId}`,
          headers: {
            'access-key': config?.widgetId,
            customerId: config?.customerId,
            'Content-Type': 'application/json',
          },
        });
        if (response?.status === 200) {
          if (!response?.data?.isBusinessOpen && !response?.data?.isSessionAvailable) {
            setShowWidget(false);
          } else {
            if (!response?.data?.isSessionAvailable && flag) {
              handleRatingSubmit();
              return;
            }
            setWidgetConfig({
              ...configData,
              widgetConfig: { ...configData?.widgetConfig, isSessionAvailable: true },
            });
            const userId = getUserId(config.widgetId);
            connectWebSocket(userId, config);
            // setUser(config?.customerId);
            setActiveWidget('ChatBot');
            setSessionAvailable(true);
            isSessionAvailable = true;
            setShowStartScreen(false);
          }
        } else {
          ConsoleUtils.log('Error Form Submit:', response);
        }
      } catch (error) {
        ConsoleUtils.error('API Error:', error);

        // Retry if attempt is under limit
        if (attempt < maxRetries) {
          retryTimeout = setTimeout(fetchConfig, 3000); // Retry after 3s
        }

        if (!navigator.onLine) {
          ConsoleUtils.log('Offline detected, retrying when online...');
          // Wait for user to come back online
          const handleReconnect = () => {
            ConsoleUtils.log('Back online. Retrying API call...');
            window.removeEventListener('online', handleReconnect);
            fetchConfig(); // Retry immediately
          };

          window.addEventListener('online', handleReconnect);
        }
      }
    };
    await fetchConfig();
  };

  const reconnectSocket = async () => {
    if (!navigator?.onLine) return;

    if (!webSocketManager.isConnected) {
      console.log('Starting socket reconnection');

      webSocketManager.removeAllSocketMessages();

      await delay(500);
      await handleFormSubmit(true); // this updates config
    }
  };

  const getTextColorBasedOnBg = (bgcolor) => {
    const rgb = bgcolor.match(/\w\w/g).map((c) => parseInt(c, 16));
    const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
    return brightness > 150 ? '#000000' : '#ffffff'; // Black text for light backgrounds, white for dark
  };

  const textColor = getTextColorBasedOnBg(bgcolor);
  const isBgLight = textColor === '#000000';

  return (
    <div className="App">
      {pageLoading ? (
        <div className="full-page-loader">
          <div className="loader-spinner"></div>
        </div>
      ) : (
        // <>
        //   {showRatingScreen ? (
        //     <RatingScreen
        //       onSubmit={handleRatingSubmit}
        //       buttonColor={bgcolor}
        //       colors={textColor}
        //       title={title}
        //       subtitle={status}
        //       config={config}
        //     />
        //   ) : (
        //     )}
        //  </>
        <>
          {showWidget ? (
            <>
              {activeWidget === 'ChatBot' ? (
                <Widget
                  handleSubmit={handleNewUserMessage}
                  handleTextInputChange={handleKeyPress}
                  // handleNewUserMessage={handleNewUserMessage}
                  title={title}
                  config={config}
                  subtitle={status}
                  fullScreenMode={true}
                  emojis={true}
                  showBadge={true}
                  showTimeStamp={true}
                  showCloseButton={true}
                  showStartScreen={showStartScreen}
                  onSubmit={handleStartScreenSubmit}
                  onFormSubmit={handleFormSubmit}
                />
              ) : (
                <WidgetMain
                  title={title}
                  config={config}
                  subtitle={status}
                  widgetBlocks={widgetBlocks}
                  activeWidget={activeWidget}
                  setActiveWidget={setActiveWidget}
                  onFormSubmit={handleFormSubmit}
                />
              )}
            </>
          ) : (
            <OfflineDisplay
              status={offlineStatus}
              message={offlineMessage}
              buttonColor={bgcolor}
              colors={textColor}
              title={title}
              subtitle={status}
            />
          )}
        </>
      )}

      <style>
        {`
      .rcw-conversation-container .rcw-header {
        background-color: ${bgcolor} !important;
        color: ${textColor};  /* Dynamically chosen color */
      }
      .rcw-conversation-container .rcw-header span {
        color: ${textColor};  /* Adjust text color */
      }
      .rcw-client {
        // background-color: ${bgcolor};
        color: ${textColor};  /* Ensure correct text color */
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        // font-family: 'Inter', sans-serif;
        letter-spacing: 0.02em;
        max-width: 340px;
      }
      .rcw-client .rcw-message-content, 
      .rcw-client .msg-doc_main {
        background-color: ${bgcolor};    
        ${isBgLight ? 'border: 1px solid #ccc;' : ''}
      }
      .App {
        color: ${textColor} !important;  /* Same logic for App component */
      }
      .rcw-conversation-container .rcw-title {
        color: ${textColor};  /* Adjust title color */
      }
      .rcw-multichoice-option>button {
        background: ${hex2rgba(bgcolor, 0.1)};
        color: ${bgcolor};
      }
      .rcw-multichoice-option>button:hover {
        background: ${hex2rgba(bgcolor, 1)};
        color: ${textColor};
      }
    `}
      </style>
    </div>
  );
};

export default App;
